import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import {
  getDefaultBaseSettingsConfigFormly,
  getPopulatesPropsSettingsConfigFormly,
} from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  getApplicationNumberFieldSettingsConfig,
  applicationNumberResponseProps,
  applicationNumberFieldParseIntoSettingsFormModel,
  applicationNumberFieldUpdateFromSettingsFormModel,
} from '../application-number-field-type.configuration';
import { fieldsBaseConfigurationFormModel } from '../shared.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomApplicationNumberInputFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = {
      ...fieldsBaseConfigurationFormModel(),
      applicationNumberFieldContentConfig: {
        url: '/application/v1/application/by-application-number/details',
        useBaseUrl: true,
        appNoLength: 19,
        compareKey: 'serviceId',
        compareOperator: '!==',
        compareValue: '',
      },
    };
    this.settingsFormlyForm = [
      ...getApplicationNumberFieldSettingsConfig(),
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      ...getPopulatesPropsSettingsConfigFormly(this.formBuilderService, [
        ...Array.from(applicationNumberResponseProps),
      ]),
    ];
    this.availableValidations.push('invalidInput', 'invalidAppNo');
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return applicationNumberFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return applicationNumberFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
